import React from 'react'
import slugify from 'slugify'

import transformLink from '~/utils/transformLink'

import ButtonArrow from '~/components/core/buttonArrow'
import Wysiwyg from '~/components/core/Wysiwyg/Wysiwyg'

const TextFull = ({ data, isProject = false }) => {
  if (!data || !data.content) {
    return <div></div>
  }
  const content = data.content

  let cta = null

  if (data.cta !== null && data.cta !== undefined) {
    cta = data.cta.fields ? data.cta.fields : data.cta
  }

  const { url, contentTypeContentful } = transformLink(cta, true, false)

  return (
    <div className="row" id={data.title && slugify(data.title)}>
      <div
        className={`col-12 lg-col-6 ${isProject ? 'lg-col-offset-1 lg-col-7 xl-col-6' : 'lg-col-offset-2'}`}
      >
        {(data.displayTitle === undefined ||
          data.displayTitle === null ||
          data.displayTitle) && (
          <h2 className="title-block text-blue">{data.title}</h2>
        )}

        <Wysiwyg
          document={content}
          isProject={isProject}
          hasTitle={
            data.displayTitle === undefined ||
            data.displayTitle === null ||
            data.displayTitle
          }
        />

        {cta !== null && (
          <div className="mt-6 lg:mt-8">
            <ButtonArrow
              text={cta.label}
              link={url}
              contentType={contentTypeContentful}
              color="purple"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default TextFull
